<template>
  <div class="container-fluid">
    <card back>
      <template slot="header">
        <h4>مجوز پرداخت هزینه</h4>
        <hr />
      </template>
      <template slot="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <h3 v-if="!AddMode">
                <a @click="OpenAdd">
                  <i class="fa fa-plus text-success"></i>
                </a>
              </h3>
              <h3 v-else>
                <a @click="CancelAdd">
                  <i class="fa fa-times text-danger"></i>
                </a>
              </h3>
            </div>
          </div>
          <div v-if="AddMode" class="row">
            <add @cancel="CancelAdd" :EditData="EditData" :Isedit="Isedit"></add>
          </div>
          <div v-else class="row">
            <ShowGrid @Edit="OpenEdit"></ShowGrid>
          </div>
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import Add from './Components/Add.vue'
import ShowGrid from './Components/ShowGrid.vue'
export default {
  components: { Card, Add, ShowGrid },

  data() {
    return {
      AddMode: false,
      Isedit: null,
      EditData: null,
    }
  },
  methods: {
    OpenEdit(data) {
      this.AddMode = true
      this.EditData = data
      this.Isedit = true
    },
    CancelAdd() {
      this.AddMode = false
      this.EditData = null
      this.Isedit = false
    },
    OpenAdd() {
      this.AddMode = true
      this.EditData = null
      this.Isedit = false
    },
  },
  props: ['rowForEdit'],
  mounted(){
    if (this.rowForEdit) {
      this.$store.state.OldDataForLog = this.rowForEdit
      this.AddMode = true
      this.Isedit = true
      this.EditData=JSON.parse(this.rowForEdit)

    }
  }
}
</script>
